import { useChatSearch } from '../ChatSearchContext';

export const useIsChatSearchDirty = () => {
  const { showResults, answers } = useChatSearch();

  const isDirty = Boolean(showResults || answers.length > 0);

  return isDirty;
};
